import { render, staticRenderFns } from "./Assertive.vue?vue&type=template&id=c29e07e0&"
import script from "./Assertive.vue?vue&type=script&lang=js&"
export * from "./Assertive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports